import React from "react";
import styles from "./style.module.scss";
import process1 from "../../../../static/process1.jpeg";
import process2 from "../../../../static/process2.jpeg";
import process3 from "../../../../static/process3.jpeg";
import FeedIn from "../../../components/FramerMotion/FeedIn";

const Process = () => {
  return (
    <div className={styles.section} id="process">
      <div className={styles.sectionInner}>
        <FeedIn>
          <div className={styles.textArea}>
            <p className={styles.subTitle}>Process</p>
            <h3 className={styles.title}>
              金型設計からプラスチック成形まで
              <br />
              トータルプロデュース。
              <br />
              ワンストップだから
              <br className={styles.br} />
              スピーディ。
            </h3>
          </div>
        </FeedIn>
        <div className={styles.processAreaWrapper}>
          <FeedIn>
            <div className={styles.processArea}>
              <div className={styles.titleArea}>
                <p className={styles.processNum}>01</p>
                <div className={styles.border} />
                <p className={styles.processTitle}>金型設計</p>
              </div>
              <p className={styles.processDescription}>
                製品の開発段階から、お客様のご要望に沿って細かな打ち合わせのもと設計します。
                <br />
                複雑なパーツにも、経験と技術力で対応します。
              </p>
              <img
                src={process1}
                alt="金型設計イメージ"
                className={styles.image}
              />
            </div>
            <div className={styles.processArea}>
              <div className={styles.titleArea}>
                <p className={styles.processNum}>02</p>
                <div className={styles.border} />
                <p className={styles.processTitle}>金型製造</p>
              </div>
              <p className={styles.processDescription}>
                金型の完成度が成形品にそのまま反映するので、高精度・高品質を追求し、
                <br />
                拘りながらもお約束した納期までに製造します。
              </p>
              <img
                src={process2}
                alt="金型設計イメージ"
                className={styles.image}
              />
            </div>
            <div>
              <div className={styles.titleArea}>
                <p className={styles.processNum}>03</p>

                <p className={styles.processTitle}>プラスチック成形</p>
              </div>
              <p className={styles.processDescription}>
                自社製造金型で成形を行うので、量産はもちろん金型トライ・調整・改造など、
                <br />
                様々な要求にも柔軟に対応できます。
                <br />
                成形品は、品質管理部門によってお客様の求める品質維持に努めています。
              </p>
              <img
                src={process3}
                alt="金型設計イメージ"
                className={styles.image}
              />
            </div>
          </FeedIn>
        </div>
      </div>
    </div>
  );
};

export default Process;
